import './css/ToolBar.css';
import { useDispatch } from "react-redux";
import { activateTool } from './toolSlice';
import { connect } from "react-redux";
import { useEffect, useRef, useState } from 'react';
import * as d3 from 'd3';
import { canDensify, canDivide, canRepeat, canClassify } from 'mascot-vis';
import { Button, Modal } from "react-bootstrap";
import * as msc from "mascot-vis";
import { addToStack, getDefaultCollectionLayout } from './Util';
import store from "./store";
import { select, joinDataItem, directSelect, updateUndoStack, updateRedoStack, updateItem } from "./canvasSlice";
import {saveAs} from "file-saver";

const tools = ["Select", "DirectSelect", "Line", "Rect", "Ellipse", "Ring", "Pen", "Text"];
const arrangements = ["Align Top", "Align Middle", "Align Bottom", "Align Left", "Align Center", "Align Right"];

const mapStateToProps = state => ({
    activeTool: state.tool.activeTool,
    selected: state.canvas.selected,
    undoStackChanged: state.canvas.undoStackChanged,
    redoStackChanged: state.canvas.redoStackChanged
});

const renderer = msc.renderer("svg", "preview")
    const scn = msc.scene();

// const drawPreview = (selectedItem, cmd, dataset, field) => {
//     if (d3.select("#preview").empty())
//         return;
//     scn.removeAll();
//     if (selectedItem && cmd && field && dataset) {
//         let item = selectedItem.duplicate();
//         scn.addChild(item);
//         if (cmd === "Repeat") {
//             let coll = scn.repeat(item, dataset, {field: field, layout: getDefaultCollectionLayout(item.bounds, dataset.getUniqueFieldValues(field).length)});
//             let vb = [coll.bounds.left, coll.bounds.top, coll.bounds.width, coll.bounds.height].join(" ");
//             d3.select("#preview").attr("viewBox", vb);
//         }
//         renderer.clear();
//         renderer.render(scn);
//     }
// }

const getUsableTbls = (item, datasets) => {
    let t = {};
    if (!item) return t;
    if (item.dataScope) {
        t[item.dataScope.dataTable.id] = item.dataScope.dataTable;
    } else {
        for (let d of datasets) {
            t[d.id] = d;
        }
    }
    return t;
}

const getOrientations = function(type, cmd) {
    if (cmd === "Divide") {
        switch (type) {
            case "rect":
                return ["horizontal", "vertical"];
            case "circle":
                return ["angular", "radial"];
            case "ring":
                return ["angular"];
            case "pie":
                return ["radial"];
            default:
                return ["horizontal", "vertical"];
        }
    } else if (cmd === "Densify") {
        return ["horizontal", "vertical"];
    }
}

function ToolBar(props) {

    const dispatch = useDispatch();
    const inputFile = useRef(null);

    const [showRepeatModal, setShowRepeatModal] = useState(false);
    //const [selectedItem, setSelectedItem] = useState(null);
    // const [datasetId, setDatasetId] = useState(null);
    //const [dataset, setDataset] = useState(undefined);
    const [cmd, setCmd] = useState(null);
    const [tbls, setTbls] = useState({});
    const [fields, setFields] = useState([]);
    const [orientations, setOrientations] = useState([]);
    const [joinMsg, setJoinMsg] = useState("");
    
    const doJoin = () => {
        setShowRepeatModal(false);
        addToStack(props.scene, props.datasets, props.undoStack);
        if (cmd === "Repeat") {
            let item = props.scene.getItem(props.selected[0]);
            if (props.selected.length > 1) {
                let sels = props.selected.map(d => props.scene.getItem(d));
                item = props.scene.glyph(...sels);
            }
            store.dispatch(select([]));
            let dataset = tbls[d3.select("#datasetSelect").property("value")],
                field = d3.select("#fieldSelect").property("value");
            let layout = getDefaultCollectionLayout(item, dataset.getUniqueFieldValues(field).length);
            let coll = props.scene.repeat(item, dataset, {field: field, layout: layout});
            if (coll.children.length < 25) {
                if (layout.numCols === 1) {
                    props.scene.axis("y", field, {item: item});
                } else if (layout.numRows === 1) {
                    props.scene.axis("x", field, {item: item});
                }
            }
            props.scene.reCreateRelatedAxes(coll);
            store.dispatch(select([coll.id]));
            store.dispatch(joinDataItem({}));
        } else if (cmd === "Divide") {
            let item = props.scene.getItem(props.selected[0]);
            store.dispatch(select([]));
            let dataset = tbls[d3.select("#datasetSelect").property("value")],
                field = d3.select("#fieldSelect").property("value"), 
                o = d3.select("#orientationSelect").property("value");
            let coll = props.scene.divide(item, dataset, {field: field, orientation: o});
            // if (item.type === "rect" && coll.layout && !coll.parent.layout) {
            if (coll.firstChild.type === "rect" && coll.layout && coll.parent.type === "scene") {
                if (coll.layout.orientation === "vertical") {
                    props.scene.axis("y", field, {item: coll.firstChild});
                } else if (coll.layout.orientation === "horizontal") {
                    props.scene.axis("x", field, {item: coll.firstChild});
                }
            }
            props.scene.reCreateRelatedAxes(coll);
            store.dispatch(select([coll.id]));
            store.dispatch(joinDataItem({}));
        } else if (cmd === "Densify") {
            let item = props.scene.getItem(props.selected[0]);
            store.dispatch(select([]));
            let dataset = tbls[d3.select("#datasetSelect").property("value")],
                field = d3.select("#fieldSelect").property("value"), 
                o = d3.select("#orientationSelect").property("value");
            let itm = props.scene.densify(item, dataset, {field: field, orientation: o});
            store.dispatch(select([itm.id]));
            store.dispatch(joinDataItem({}));
        } else if (cmd === "Classify") {
            let item = props.scene.getItem(props.selected[0]);
            store.dispatch(select([]));
            let field = d3.select("#fieldSelect").property("value");
            props.scene.classify(item, {field: field});
            let layout = getDefaultCollectionLayout(item.firstChild.firstChild, Math.max(...item.children.map(d => d.children.length)));
            props.scene.setProperties(item.firstChild, {layout: layout});
            let layout2 = getDefaultCollectionLayout(item.firstChild, item.children.length);
            props.scene.setProperties(item, {layout: layout2});
            //item.layout = msc.layout("grid", layout2);
            if (item.children.length < 25) {
                props.scene.axis("y", field, {item: item.firstChild});
            }
            store.dispatch(select([item.id]));
            store.dispatch(joinDataItem({}));
        }
    }

    const switchTool = (t) => {
        d3.select("#textElement").style("visibility", "hidden");
        props.renderer.render(props.scene);
        switch (t) {
            case "Rect":
            case "Ellipse":
            case "Line":
            case "Ring":
            case "Pen":
                dispatch(directSelect(null));
                dispatch(select([]));
                //d3.select("#evtLayer").style("cursor", "crosshair");
                break;
            case "Select":
                // dispatch(select([]));
                d3.select("#evtLayer").style("cursor", "default");
                dispatch(directSelect(null));
                break;
            case "DirectSelect":
                //d3.select("#evtLayer").style("cursor", "default");
                dispatch(select([]));
                break;
            default:
                //d3.select("#evtLayer").style("cursor", "default");
                break;
        }
        dispatch(activateTool(t));
    }

    const repeatBtnClicked = (e) => {
        switchTool("Select");
        if (props.selected.length === 0) return;
        setCmd("Repeat");
        setShowRepeatModal(true);
        let item = props.scene.getItem(props.selected[0]);
        let t = getUsableTbls(item, props.datasets);
        // let options = d3.select("#datasetSelect").selectAll("option").data(Object.values(t));
        // options.enter().append("option").merge(options).property("key", d => d.id).text(d => d.name);
        // options.exit().remove();
        setTbls(t);
        let usedFields = item.firstChild && item.firstChild.dataScope ? item.firstChild.dataScope.fields: [], 
            fields = t[Object.keys(t)[0]].nonNumericFields.concat(["atlas_rowId"]);
        fields = fields.filter(d => usedFields.indexOf(d) < 0);
        setFields(fields);
    }

    const divideBtnClicked = (e) => {
        switchTool("Select");
        if (props.selected.length === 0) return;
        setCmd("Divide");
        setShowRepeatModal(true);
        let item = props.scene.getItem(props.selected[0]);
        setOrientations(getOrientations(item.type, "Divide"));
        let t = getUsableTbls(item, props.datasets);
        setTbls(t);
        let usedFields = item.dataScope ? item.dataScope.fields: [],
            fields = t[Object.keys(t)[0]].nonNumericFields.concat(["atlas_rowId"]);
        fields = fields.filter(d => usedFields.indexOf(d) < 0);
        setFields(fields);
    }

    const densifyBtnClicked = (e) => {
        switchTool("Select");
        if (props.selected.length === 0) return;
        setCmd("Densify");
        setShowRepeatModal(true);
        let item = props.scene.getItem(props.selected[0]);
        setOrientations(getOrientations(item.type, "Densify"));
        let t = getUsableTbls(item, props.datasets);
        setTbls(t);
        let usedFields = item.dataScope ? item.dataScope.fields: [],
            fields = t[Object.keys(t)[0]].nonNumericFields.concat(["atlas_rowId"]);
        fields = fields.filter(d => usedFields.indexOf(d) < 0);
        setFields(fields);
    }

    const classifyBtnClicked = (e) => {
        switchTool("Select");
        if (props.selected.length === 0) return;
        setCmd("Classify");
        setShowRepeatModal(true);
        let item = props.scene.getItem(props.selected[0]);
        // setOrientations(getOrientations(item.type, "Densify"));
        let t = getUsableTbls(item, props.datasets);
        setTbls(t);
        let usedFields = item.dataScope ? item.dataScope.fields: [],
            fields = t[Object.keys(t)[0]].nonNumericFields.concat(["atlas_rowId"]);
        fields = fields.filter(d => usedFields.indexOf(d) < 0);
        setFields(fields);
    }

    const exportSVG = (e) => {
        let svg = document.getElementById("canvas");
        var serializer = new XMLSerializer();
        var source = serializer.serializeToString(svg);

        //add name spaces.
        if(!source.match(/^<svg[^>]+xmlns="http:\/\/www\.w3\.org\/2000\/svg"/)){
            source = source.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
        }
        if(!source.match(/^<svg[^>]+"http:\/\/www\.w3\.org\/1999\/xlink"/)){
            source = source.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
        }

        //add xml declaration
        source = '<?xml version="1.0" standalone="no"?>\r\n' + source;
        let tbls = props.scene.getDataTables();
        let fname = (Object.values(tbls).length > 0) ? Object.values(tbls)[0].name + ".svg" : "visualization.svg";
        saveAs(new Blob([source], {"type":"text/plain;charset=utf-8"}), fname);
    }

    const saveScene = (e) => {
        let tbls = props.scene.getDataTables();
        let fname = (Object.values(tbls).length > 0) ? Object.values(tbls)[0].name + ".msc" : "visualization.msc";
        let scn = JSON.stringify(props.scene.toJSON());
        saveAs(new Blob([scn], {"type":"text/plain;charset=utf-8"}), fname);
    }

    const fileChanged = function(e) {
        e.stopPropagation();
        e.preventDefault();
        let f = e.target.files[0];
        const reader = new FileReader();
        reader.onload = function() {
            props.loadScene(JSON.parse(reader.result));
            props.resetStacks();
        }
        reader.readAsText(f);
    }

    const undo = (e) => {
        // console.log("undoing", props.undoStack.length);
        if (props.undoStack.length === 0) return;
        addToStack(props.scene, props.datasets, props.redoStack, "redo");

        let scn = props.undoStack.pop();
        props.loadScene(JSON.parse(scn));
        // console.log("finished undo", props.undoStack.length);
        store.dispatch(updateUndoStack({length: props.undoStack.length}));
    }

    const redo = (e) => {
        if (props.redoStack.length === 0) return;
        addToStack(props.scene, props.datasets, props.undoStack);

        let scn = props.redoStack.pop();
        props.loadScene(JSON.parse(scn));
        store.dispatch(updateRedoStack({length: props.redoStack.length}));
        //props.setRedoStack(props.redoStack.slice());
    }

    const openScene = (e) => {
        inputFile.current.click();
    }

    const updatePreview = () => {
        if (d3.select("#preview").empty())
            return;
        scn.clear();
        let selected = props.scene.getItem(props.selected[0]),
            dataset = tbls[d3.select("#datasetSelect").property("value")],
            field = d3.select("#fieldSelect").property("value");
        if (selected && cmd && field && dataset) {
            let item = selected.duplicate();
            if (item.fillColor === "none")
                item.fillColor = "#f5f5f5";
            item.strokeColor = "#222";
            scn.addChild(item);
            if (cmd === "Repeat") {
                if (props.selected.length > 1) {
                    let dups = props.selected.map(d => props.scene.getItem(d)).map(d => d.duplicate());
                    item = scn.glyph(...dups);
                }
                let coll = scn.repeat(item, dataset, {field: field, layout: getDefaultCollectionLayout(item, dataset.getUniqueFieldValues(field).length)});
                let vb = [coll.bounds.left - 2, coll.bounds.top - 2, coll.bounds.width + 4, coll.bounds.height + 4].join(" ");
                d3.select("#preview").attr("viewBox", vb);
            } else if (cmd === "Divide") {
                item.strokeWidth = Math.max(item.strokeWidth, 1);
                let o = d3.select("#orientationSelect").property("value");
                let coll = scn.divide(item, dataset, {field: field, orientation: o});
                let vb = [coll.bounds.left - 2, coll.bounds.top - 2, coll.bounds.width + 4, coll.bounds.height + 4].join(" ");
                d3.select("#preview").attr("viewBox", vb);
            } else if (cmd === "Densify") {
                item.strokeWidth = Math.max(item.strokeWidth, 1);
                let o = d3.select("#orientationSelect").property("value");
                let itm = scn.densify(item, dataset, {field: field, orientation: o});
                scn.setProperties(itm, {"vxShape": "rect", "vxWidth": 4, "vxHeight": 4, "vxStrokeColor": "#1592e6", "vxStrokeWidth": 1});
                let vb = [itm.bounds.left - 2, itm.bounds.top - 2, itm.bounds.width + 4, itm.bounds.height + 4].join(" ");
                d3.select("#preview").attr("viewBox", vb);
            } else if (cmd === "Classify") {
                item.strokeWidth = Math.max(item.strokeWidth, 1);
                scn.classify(item, {field: field});
                let layout = getDefaultCollectionLayout(item.firstChild.firstChild, Math.max(...item.children.map(d => d.children.length)));
                scn.setProperties(item.firstChild, {layout: layout});
                let layout2 = getDefaultCollectionLayout(item.firstChild, item.children.length);
                scn.setProperties(item, {layout: layout2});
                //item.layout = msc.layout("grid", {"numCols": 1, "rowGap": 20})
                let vb = [item.bounds.left - 2, item.bounds.top - 2, item.bounds.width + 4, item.bounds.height + 4].join(" ");
                d3.select("#preview").attr("viewBox", vb);
            }
            renderer.clear();
            renderer.render(scn);
        }
    }

    const updateMsg = () => {
        if (props.selected.length === 0 || !cmd) {
            setJoinMsg("");
            return;
        }
        let selected = props.scene.getItem(props.selected[0]),
            dataset = tbls[d3.select("#datasetSelect").property("value")],
            field = d3.select("#fieldSelect").property("value");
        let vals = dataset.getUniqueFieldValues(field), num, msg = "";
        if (selected.dataScope) {
            num = selected.dataScope.getUniqueFieldValues(field).length;
        } else {
            num = vals.length;
        }
        if (cmd === "Repeat") {
            msg = [num, props.selected.length > 1 ? "glyphs" : selected.type + "s", "will be created,"].join(" ");
        } else if (cmd === "Divide") {
            msg = ["Divide the", selected.type, "into", num, "parts,"].join(" ");
        } else if (cmd === "Densify") {
            if (selected.type === "rect") {
                let o = d3.select("#orientationSelect").property("value");
                msg = ["Densify the", o === "horizontal" ? "top/bottom side" : "left/right side", "of the rect with", num, "vertices,"].join(" ");
            } else {
                msg = ["Densify the", selected.type, "with", num, "vertices, one for each"].join(" ");
            }
        } else if (cmd === "Classify") {
            msg = ["Group the", selected.children.length, selected.firstChild.type + "s", "into",  num, "collections"].join(" ");
        }
        d3.select("#msg").text(msg);
    }

    useEffect(() => {
        d3.selectAll(".iconBtn").classed("active", false);
        d3.select("#"+props.activeTool+"Btn").classed("active", true);
        switch (props.activeTool) {
            case "Rect":
            case "Ellipse":
            case "Line":
            case "Ring":
            case "Pen":
                d3.select("#evtLayer").style("cursor", "crosshair");
                break;
            case "Select":
                d3.select("#evtLayer").style("cursor", "default");
                break;
            case "DirectSelect":
                d3.select("#evtLayer").style("cursor", "default");
                break;
            default:
                d3.select("#evtLayer").style("cursor", "default");
                break;
        }
    }, [props.activeTool]);

    //manually trigger change event because repopulating options does not fire change event
    useEffect(() => {
        let fs = document.getElementById("fieldSelect");
        if (fs) {
            // let evt = document.createEvent("Event");
            // evt.initEvent('change', true, false);
            let evt = new CustomEvent('change', {bubbles: true, cancelable: false});
            fs.dispatchEvent(evt);
        }
    }, [fields])

    //TODO: need to use mascot's canAlign when it is finalized
    const canAlign = (items, scene) => {
        if (items.length < 2) return false;
        for (let item of items) {
            if (item.parent !== scene)
                return false;
        }
        return true;
    }

    //TODO: need to use align constraints in mascot when it's ready
    const doAlign = (dir) => {
        // let items = props.selected.map(d => props.scene.getItem(d));
        // let cstrs = props.scene.getRelatedConstraints(items);
        // let o = ["top", "middle", "bottom"].indexOf(dir) >= 0 ? "vertical" : "horizontal";
        // for (let c of cstrs) {
        //     if (c.orientation === o) {
        //         props.scene.removeConstraint(c);
        //     }
        // } 
        // props.scene.align(items, dir);
        let newPos, items = props.selected.map(d => props.scene.getItem(d));
        switch(dir) {
            case "bottom":
            case "right":
                newPos = Math.max(...items.map(d => d.bounds[dir]));
                break;
            case "center":
            case "middle":
                newPos = d3.mean(items.map(d => d.bounds[dir]));
                break;
            default:
                newPos = Math.min(...items.map(d => d.bounds[dir]));
                break;
        }
        if (["top", "middle", "bottom"].indexOf(dir) >= 0)
            items.forEach(d => props.scene.translate(d, 0, newPos - d.bounds[dir]));
        else
            items.forEach(d => props.scene.translate(d, newPos - d.bounds[dir], 0));
        store.dispatch(updateItem({id: items[0].id, type: items[0].type, properties: {x: items[0].x, y: items[0].y}}));
        props.renderer.render(props.scene);
    }

    useEffect(() => {
        let selectors = {
            "#repeatBtn": false,
            "#divideBtn": false,
            "#densifyBtn": false,
            "#classifyBtn": false,
            ".alignBtn": false
        }; 

        if (props.selected.length === 0 || props.datasets.length === 0) {
            for (let s in selectors) {
                selectors[s] = true;
            }
        } else {
            let items = props.selected.map(d => props.scene.getItem(d));
            // for (let item of items) {
            //     if (!item) {
            //         for (let s in selectors)
            //             selectors[s] = true;
            //         break;
            //     }
            // }
            if (items.length > 1) {
                selectors["#divideBtn"] = true;
                selectors["#densifyBtn"] = true;
                selectors["#classifyBtn"] = true;
            } else {
                selectors["#divideBtn"] = !canDivide(items[0]);
                selectors["#densifyBtn"] = !canDensify(items[0]);
                selectors["#classifyBtn"] = !canClassify(items[0]);
                selectors[".alignBtn"] = !canAlign(items, props.scene);
            }
            selectors["#repeatBtn"] = !canRepeat(items);
        }
        for (let s in selectors) {
            d3.selectAll(s).property("disabled", selectors[s]);
        }
    }, [props.selected, props.scene, props.datasets]);

    useEffect(() => {
        d3.select("#undoBtn").property("disabled", props.undoStackChanged.length <= 0);
    }, [props.undoStackChanged]);

    useEffect(() => {
       d3.select("#redoBtn").property("disabled", props.redoStackChanged.length <= 0);
    }, [props.redoStackChanged]);

    useEffect(() => {
        d3.select("#undoBtn").property("disabled", props.undoStack.length <= 0);
        d3.select("#redoBtn").property("disabled", props.redoStack.length <= 0);
    }, [props.undoStack, props.redoStack])

    return (
        <div>
            <div className="myToolBar">
                <div className="myBtnGroup">
                    <button key="open" className="myTextBtn" id="openBtn" onClick={openScene}>Open</button>
                    <input type='file' id='scnFile' ref={inputFile} style={{display: 'none'}} accept=".msc" onChange={fileChanged}/>
                    <button key="save" className="myTextBtn" id="saveBtn" onClick={saveScene}>Save</button>
                    <button key="export" className="myTextBtn" id="exportBtn" onClick={exportSVG}>Export</button>
                </div>
                <div className="myBtnGroup">
                    <button key="undo" className="myTextBtn" id="undoBtn" onClick={undo}>Undo</button>
                    <button key="redo" className="myTextBtn" id="redoBtn" onClick={redo}>Redo</button>
                </div>
                <div className="myBtnGroup">
                    {tools.map(t => <button key={t} className="iconBtn" title={t} id={t+"Btn"} tool={t} onClick={(e) => switchTool(e.target.getAttribute("tool"))}></button>)}
                </div>
                <div className="myBtnGroup">
                    <button key="repeat" className="myTextBtn" id="repeatBtn" onClick={repeatBtnClicked}>Repeat</button>
                    <button key="divide" className="myTextBtn" id="divideBtn" onClick={divideBtnClicked}>Divide</button>
                    <button key="densify" className="myTextBtn" id="densifyBtn" onClick={densifyBtnClicked}>Densify</button>
                    <button key="classify" className="myTextBtn" id="classifyBtn" onClick={classifyBtnClicked}>Classify</button>
                </div>
                <div className="myBtnGroup">
                    {arrangements.map(t => <button key={t.replace(" ", "")} className="alignBtn" dir={t.split(" ")[1].toLowerCase()} title={t} id={t.replace(" ", "")+"Btn"} onClick={(e) => doAlign(e.target.getAttribute("dir"))}></button>)}
                </div>
            </div>
            <Modal show={showRepeatModal} onShow={(e)=>{updatePreview();updateMsg();}}  backdrop="static" keyboard={false}>
                <Modal.Header>
                <Modal.Title>{cmd}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <div style={{"clear": "both", "marginBottom": "10px"}}>
                    <div id="msg" style={{"clear": "both", "marginBottom": "7px", "display": "block"}}>{joinMsg}</div>
                    one for each <select id="fieldSelect" onChange={(e)=>{updatePreview();updateMsg();}} style={{"marginLeft": "8px"}}>
                        {fields.map(o => <option value={o} key={o}>{o === "atlas_rowId" ? "row of data" : o}</option>)}
                    </select>
                    <div style={{"marginTop": "12px", "clear": "left"}}>from dataset 
                        <select id="datasetSelect" onChange={(e) => {setFields(tbls[e.target.value].nonNumericFields.concat(["atlas_rowId"]));}} style={{"marginLeft": "7px"}}>
                            {Object.values(tbls).map( o => <option value={o.id} key={o.id}>{o.name}</option>)}
                        </select>
                    </div>
                    <div style={{"marginTop": "15px", "display": cmd === "Repeat" || cmd === "Classify" || (cmd === "Densify" && props.selected[0] && props.scene.getItem(props.selected[0]).type !== "rect") ? "none" : "block"}}>
                        Orientation 
                        <select id="orientationSelect" onChange={(e)=>{updatePreview()}} style={{"marginLeft": "7px"}}>
                            {orientations.map(o => <option value={o} key={o}>{o}</option>)}
                        </select>
                    </div>
                </div>
                <svg id="preview" style={{"width": "470px", "height": "180px", "border": "solid 0px #ddd", "padding": "5px"}}></svg>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={(e) => {setShowRepeatModal(false)}}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={doJoin}>OK</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )

}

export default connect(mapStateToProps)(ToolBar);
